/* eslint-disable */
import { produce } from "immer";
import { create } from "zustand";


export type AppliedCoupon = {
  dgCouponCode: string;
  message : string;
  reason: string;
  valid: boolean;
};

export type BuyVerifyResponseData = {
  totalAmountPayable: any;
  amount: number;
  weight: number;
  gst: number;
  cess: number;
  discountPercent: number;
  discountAmount: number;
  totalAmountBeforeDiscount: number;
  promoCodeDiscountAmount: number;
  totalAmountAfterPromoCodeDiscount: number;
  totalAmount: number;
  roundOffAmount: number;
  payableAmount: number;
  buyLotId: string;
  error: boolean;
  message: string;
  msgKey: string;
  appliedCouponCodes: AppliedCoupon[] | null;
  goldAmount: number;
  goldWeight:number;
};

export const BuyVerifyInitialData = {
  amount: 0,
  weight: 0,
  gst: 98,
  cess: 0,
  discountPercent: 0,
  discountAmount: 0,
  totalAmountBeforeDiscount: 0,
  promoCodeDiscountAmount: 0,
  totalAmountAfterPromoCodeDiscount: 0,
  totalAmount: 0,
  roundOffAmount: 0,
  payableAmount: 0,
  totalAmountPayable: 0,
  buyLotId: "",
  error: false,
  message: "",
  msgKey: "",
  appliedCouponCodes: null,
  goldAmount:0,
  goldWeight:0,
};
type BuyVerify = {
  option: string;
  verifyData: BuyVerifyResponseData;
  buyInputGold: number;
};

const initialState: BuyVerify = {
  option: "rupees",
  verifyData: BuyVerifyInitialData,
  buyInputGold: 0,
};

export type BuyVerifyStore = {
  updateOption: (option: BuyVerify["option"]) => void;
  updateResponse: (VerifyData: BuyVerify["verifyData"]) => void;
  updateBuyInput: (buyInput: BuyVerify["buyInputGold"]) => void;
  resetBuyVerifyData: () => void;
};
export const useBuyVerifyStore = create<BuyVerify & BuyVerifyStore>((set) => ({
  ...initialState,
  updateOption: (Option: string) => {
    set({
      option: Option,
    });
  },
  updateResponse: (verifyData) => {
    set(
      produce((state: BuyVerify) => {
        state.verifyData = verifyData;
      })
    );
  },
  updateBuyInput: (updateBuyInput) => {
    set({
      buyInputGold: updateBuyInput,
    });
  },
  resetBuyVerifyData: () => set(initialState),
}));
